// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"HeroSection_heroSection__2B0ne","hasLogoList":"HeroSection_hasLogoList__ASLzp"};